module.exports = __webpack_public_path__ + "static/media/Crystal Zeng.795056b4.png";